{
  "id": "campaign-084",
  "name": "Shaggy Hollow",
  "seed": "campaign:84",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    ",,,,L__L,,,,",
    ",,,,,__,,,,,",
    ",i,i,__,i,i,",
    ",,,,,__,,,,,",
    ",,,,T__T,,,,",
    ",,h,,__..h,,",
    "____________",
    ",,T,i__i.T.,",
    ",,,,,__....,",
    ",...,__#.x.,",
    ",...,__....,",
    ",%%,i__i..,,",
    ",%,,,__,,,,,",
    ",,,,,,,x,,..",
    ",,,,,,,,...S"
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 10,
      "y": 9
    },
    {
      "kind": "rabbit",
      "x": 3,
      "y": 9
    },
    {
      "kind": "squirrel",
      "x": 7,
      "y": 5
    },
    {
      "kind": "squirrel",
      "x": 8,
      "y": 11
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 10,
      "y": 8
    },
    {
      "kind": "gas",
      "x": 2,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 4
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 14
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 0
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 14
    },
    {
      "kind": "rare",
      "x": 3,
      "y": 6
    }
  ],
  "generatorVersion": 3,
  "level": 84,
  "biome": "cemetery",
  "par": {
    "reel": 13324,
    "push": 8016,
    "selfPropelled": 7500,
    "tractor": 4190,
    "zeroTurn": 4924,
    "fairway": 2868
  },
  "routeTries": {
    "par": {
      "reel": 21,
      "push": 20,
      "selfPropelled": 2,
      "tractor": 23,
      "zeroTurn": 1,
      "fairway": 14
    }
  }
}
